/**
 * 책별 공개 페이지(muroo.kr/book/<isbn>)로 가는 길.
 *
 * 모든 책에 페이지가 있는 것은 아니다. 소개문이 짧아 만들지 않은 책이 있고,
 * 방금 담긴 새 책은 아직 만들어지기 전이다. 없는 주소로 보내면 404 가 아니라
 * 앱 첫 화면이 뜬다(호스팅이 모든 주소를 index.html 로 되돌린다) — 공유받은
 * 사람이 책 대신 로그인 화면을 보게 된다.
 *
 * 그래서 만들어 둔 ISBN 목록을 확인하고서만 길을 연다. 목록은 페이지를
 * 만들 때 scripts/build-book-pages.mjs 가 함께 내보낸다.
 */

import { useEffect, useState } from "react";

let ready = null;
let known = null;

/** 목록을 한 번만 받아 둔다. 실패하면 '없음' 으로 두고 버튼을 내지 않는다. */
function load() {
  if (!ready) {
    ready = fetch("/book-pages.json")
      .then((r) => (r.ok ? r.json() : null))
      .then((list) => { known = new Set(Array.isArray(list) ? list : []); })
      .catch(() => { known = new Set(); });
  }
  return ready;
}

/**
 * 이 책에 공개 페이지가 있는가. 아직 모르면 false.
 *
 * 훅이어야 한다. 처음에는 목록이 없어 false 인데, 받아온 뒤 상태가 바뀌지
 * 않으면 React 가 다시 그리지 않아 버튼이 영영 나오지 않는다. 모듈 전역
 * 변수만 두었다가 실제로 그 일이 났다 — 화면을 억지로 다시 그리게 하자
 * 그제서야 버튼이 나타났다.
 */
export function useBookPage(isbn) {
  const [has, setHas] = useState(() => (known ? known.has(String(isbn ?? "")) : false));
  useEffect(() => {
    let alive = true;
    load().then(() => { if (alive) setHas(known.has(String(isbn ?? ""))); });
    return () => { alive = false; };
  }, [isbn]);
  return has;
}

export function bookPageUrl(isbn) {
  return `https://muroo.kr/book/${isbn}`;
}
